import { 
    USER_ADD,
    USER_REMOVE,
    UserState,
    USER_EDIT
} from "./types";
import UserAPI from "../../api/user";
import { ThunkDispatch } from "redux-thunk";

export type AddUserType = (username: string, password: string, type: string) => Promise<UserState>;
export const addUser = (username: string, password: string, type: string) => (dispatch: ThunkDispatch<{},{},any>) =>
{
    let action = (userData: UserState) =>
    {
        dispatch({
            type: USER_ADD,
            account: userData.account,
            username: userData.username,
            id: userData.id,
            userType: userData.type,
            isElevatedUser: userData.isElevatedUser
        });
        return new Promise<UserState>(resolve=>resolve(userData));
    };
    return UserAPI.addUser(username, password, type).then(action);
}

export type EditUserType = (id: string, account: string, username: string, password: string) => Promise<UserState>;
export const editUser = (id: string, account: string, username: string, password: string) => (dispatch: ThunkDispatch<{},{},any>) =>
{
    let action = (userData: UserState) =>
    {
        if(userData)
        {
            dispatch({
                type: USER_EDIT,
                account: userData.account,
                username: userData.username,
                id: userData.id,
                userType: userData.type,
                isElevatedUser: userData.isElevatedUser
            });
        }
        return new Promise<UserState>(resolve=>resolve(userData));
    };
    return UserAPI.editUser(id, account, username, password).then(action);
}

export type RemoveUserType = (id: string, account: string) => Promise<UserState>;
export const removeUser = (id: string, account: string) => (dispatch: ThunkDispatch<{},{},any>) =>
{
    let action = (user: UserState) =>
    {
        dispatch({
            type: USER_REMOVE,
            account: account
        });
        return new Promise<UserState>(resolve=>resolve(user));
    };
    return UserAPI.removeUser(id).then(action);
}